import React from 'react';
import { User, Building2 } from 'lucide-react';

const Profile = () => {
  return (
    <div className="main-content page-profile">
      
    </div>
  );
};

export default Profile; 

